(function() {
  const COOKIE_NAME = 'rrBypass_v2';
  const EXPIRY_MS   = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  // helper to read a cookie by name
  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  // build an expires=... string for 24h from now
  const expires = new Date(Date.now() + EXPIRY_MS).toUTCString();

  const referrer   = document.referrer;
  const currentUrl = window.location.href;

  // only run once per 24h for Google-referred visitors who don’t already have ?rr
  if (
    referrer.includes('google.com') &&
    !/[?&]rr(?:[=&]|$)/.test(currentUrl) &&
    !getCookie(COOKIE_NAME)
  ) {
    // set cookie that expires in 24h
    document.cookie = COOKIE_NAME + '=1; expires=' + expires + '; path=/';

    // append ?rr (or &rr) and redirect
    const url = new URL(currentUrl);
    url.search += url.search ? '&rr' : '?rr';
    window.location.replace(url.toString());
  }
})();